import { useMemo, useState } from "react";
import { useI18n, t } from "@bookingcom/lingojs-react";
export const useUnifiedPriceTagPriceBreakdownController = () => {
    const [showPriceBreakdown, setShowPriceBreakdown] = useState(false);
    const i18n = useI18n();
    const contentTitle = useMemo(() => i18n.trans(t("flights_price_details_title")), [i18n]);
    const closeAriaLabel = useMemo(() => i18n.trans(t("close")), [i18n]);
    return { contentTitle, closeAriaLabel, showPriceBreakdown, setShowPriceBreakdown };
};
